import React, { useEffect, useState } from "react";
import { useStaticQuery, graphql } from "gatsby";
import { useLanguageContext } from "../../contexts/language-context";
import snarkdown from "snarkdown";

// Styles
import "./alert-stripe.bootstrap.scss";

const AlertStripe = () => {
  const isSpanish = useLanguageContext();

  const alertStripeMessageData = useStaticQuery(graphql`
    query {
      messages: allStrapiAlertStripeMessages(
        filter: { Active: { eq: true } }
        sort: { fields: [DisplayOrder], order: ASC }
      ) {
        nodes {
          id
          Active
          BackgroundColorClass
          DisplayOrder
          MessageText
          MessageText_es
          StartDateTime
          EndDateTime
        }
      }
    }
  `);
  const messageNodes = alertStripeMessageData.messages.nodes;

  const [activeMessages, setActiveMessages] = useState([]);

  // run only once on page load
  useEffect(() => {
    const now = Date.now();
    setActiveMessages(
      messageNodes.filter((mesg) => {
        // if a message does not have a start time - consider it active.
        if (mesg.StartDateTime !== null) {
          const start = new Date(mesg.StartDateTime);
          if (now < start.getTime()) {
            // the message has not started yet - make it inactive.
            return false;
          }
        }
        // if a message does not have an end time - consider it active.
        if (mesg.EndDateTime !== null) {
          const end = new Date(mesg.EndDateTime);
          if (now > end.getTime()) {
            // the message has expired - make it inactive.
            return false;
          }
        }
        // otherwise consider the message active.

        return true;
      })
    );
  }, []);

  return (
    <div id="alert-stripe-messages">
      {activeMessages.map((mesg, index) => {
        const mesgText = isSpanish ? mesg.MessageText_es : mesg.MessageText;
        return (
          <>
            {mesgText && mesgText.trim().length > 0 && (
              <div key={mesg.id} id={`alert-stripe-message-${index+1}`} className={`bg-${mesg.BackgroundColorClass}`}>
                <div className="container">
                  <div className="alert-stripe-item">
                    {mesg.BackgroundColorClass === "warning" ||
                    mesg.BackgroundColorClass === "light" ||
                    mesg.BackgroundColorClass === "white" ? (
                      <div className="text-black" dangerouslySetInnerHTML={{ __html: snarkdown(mesgText) }}></div>
                    ) : (
                      <div className="text-white" dangerouslySetInnerHTML={{ __html: snarkdown(mesgText) }}></div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </>
        );
      })}
    </div>
  );
};
export default AlertStripe;
